import Styled from 'styled-components';

const CheckboxGroupContainer = Styled.div`
  height: 100%;

  & .ant-checkbox-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    & .ant-checkbox-inner {
      height: 20px;
      width: 20px;
    }
    & .ant-checkbox + span {
      margin-top: 10px;
    }
  }
`;

const CheckboxContainer = Styled(CheckboxGroupContainer)`
  height: 100%;
  margin: 0 0 24px;
`;

export { CheckboxContainer, CheckboxGroupContainer };
